export const vrmUKRegex = /^[a-zA-Z0-9\s]{2,10}$/i;
export const vrmFRRegex = /^[a-zA-Z0-9\-/._\s]{2,14}$/i;
